var theme = {
  initHeader: function() {
    $(window).on('scroll', function() {
      if ($(window).scrollTop() > 30) {
        $('header').addClass('scrolled');
      } else {
        $('header').removeClass('scrolled');
      }
    });
  },

  initMobileMenu: function() {
    $('html').on('click', function(evt) {
      if ($(evt.target).closest('header').length == 0 && $('ul.main-menu').hasClass('active')) {
        evt.preventDefault();
        evt.stopPropagation();
        theme.toggleMobileMenu(false);
      }
    });

    $(document).on('click', 'a.menu-toggle', function(evt) {
      evt.preventDefault();
      var active = !$(this).hasClass('active');
      theme.toggleMobileMenu(active);
    });

    $(document).on('click', 'ul.main-menu li.has-submenu > a', function(evt) {
      if ($('ul.main-menu').css('position') === "absolute") {
        evt.preventDefault();

        $(this).closest('li').addClass('active');
      }
    });

    $(document).on('click', 'ul.main-menu li.menu-back a', function(evt) {
      evt.preventDefault();
      $(this).closest('li.active').removeClass('active');
    });


    $('ul.foot-menu > li.has-submenu > a').on('click', function(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      if ($(this).closest('li').hasClass('active')) {
        $('ul.foot-menu li.active').removeClass('active');
      } else {
        $('ul.foot-menu li.active').removeClass('active');
        $(this).closest('li').addClass('active')
      }
    });
  },

  toggleMobileMenu: function(active) {
    $('a.menu-toggle, ul.main-menu').toggleClass('active', active);
    $('ul.main-menu li.active').removeClass('active');
  },

  initProductTabs: function() {
    $(document).on('click', '.product-tabs > a', function(evt) {
      evt.preventDefault();
      var panelID = $(this).attr('href');
      if ($('.product-tabs ' + panelID).hasClass('visible')) {
        $(this).removeClass('active');
        $('.product-tabs ' + panelID).removeClass('visible');
      } else {
        $('.product-tabs > a').removeClass('active');
        $(this).addClass('active');
        $('.product-tabs .panel').removeClass('visible');
        $('.product-tabs ' + panelID).addClass('visible');
      }
    });
  },

  initProductSizeGuide: function() {
    $(document).on('click', '#show-sizing-guide', function(evt) {
      evt.preventDefault();
      $('.product-tabs > a').removeClass('active');
      $('.product-tabs .panel').removeClass('visible');

      $('.product-tabs > a[href="#sizing-guide"]').addClass('active');
      $('.product-tabs .panel#sizing-guide').addClass('visible');

      $('html, body').stop().animate({
        scrollTop: $('.product-tabs > a[href="#sizing-guide"]').offset().top - 70
      }, 500);
    })
  },

  initCollectionSorting: function() {
    if ($('.collection-sorting').length == 0) return;

    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    $('#sort-by').on('change', function() {
        Shopify.queryParams.sort_by = $(this).val();
        location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
      });
  },

  slideshowTimers: {},
  initSlideshow: function() {
    $('.slideshow').each(function() {
      var slideshow = $(this);
      theme.slideshowTimers[slideshow] = null;
      if (slideshow.find('.slide.active').length == 0) {
        theme.showSlide(slideshow, 0);
      }

      slideshow.find('video').each(function() {
        var video = $(this)[0];
        video.onended = function() {
          theme.showNextSlide(slideshow);
        };
      });

      slideshow.on('click', 'ul.bullets li a', function(evt) {
        evt.preventDefault();

        if ($(this).hasClass('active')) return;

        theme.showSlide(slideshow, $(this).data('index'));
      });
    });
  },

  showNextSlide: function(slideshow) {
    var currentSlide = slideshow.find('.slide.active');
    var nextSlide = currentSlide.next('.slide');
    if (nextSlide.length == 0) {
      nextSlide = slideshow.find('.slide').first();
    }
    if (currentSlide.data('index') != nextSlide.data('index')) {
      this.showSlide(slideshow, nextSlide.data('index'));
    }
  },

  showSlide: function(slideshow, slideIdx) {
    if (slideshow.find('.slide.active').hasClass('slide-video')) {
      var video = slideshow.find('.slide.active').find('video')[0];
      video.pause();
      video.currentTime = 0;
    }


    slideshow.find('.slide.previous').removeClass('previous');
    slideshow.find('.slide.active').addClass('previous').removeClass('active');
    slideshow.find('.slide[data-index=' + slideIdx + ']').addClass('active');
    slideshow.find('ul.bullets li a.active').removeClass('active');
    slideshow.find('ul.bullets li a[data-index=' + slideIdx + ']').addClass('active');

    var isVideo = slideshow.find('.slide.active').hasClass('slide-video');

    if (parseInt(slideshow.data('autorotate')) > 0 &&
        slideshow.find('.slide').length > 1) {
        //    &&
        // slideshow.find('.slide[data-index=' + slideIdx + ']').hasClass('slide-image')) {
      if (theme.slideshowTimers[slideshow]) {
        clearTimeout(theme.slideshowTimers[slideshow]);
        theme.slideshowTimers[slideshow] = null;
      }

      if (isVideo) {
        var video = slideshow.find('.slide.active').find('video')[0];
        video.play();
      } else {
        theme.slideshowTimers[slideshow] = setTimeout(function() {
          theme.showNextSlide(slideshow);
        }, parseInt(slideshow.data('autorotate')));
      }
    }
  },

  
  
  
  
  initProductImages: function() {
    if ($('.product-images').length == 0) return;

    // if ($('.product-images .thumbs .screen').width() === $('.product-images .thumbs .screen div').width()) {
    //   $('.product-images a.prev, .product-images a.next').remove();
    // }

    theme.updateProductImagesArrows();
    
    //Added by Ken to fix swatch click main image change
    $(document).on('click', '.swatch input', function(evt) {
      $('swatch input').removeClass('active');
      $(this).addClass('active');
      $('.product-images .big-image').css('background-image', 'url("' + $(this).attr('data-kork-main-image') + '")');
    });
    
    $(document).on('click', '.product-images .thumbs .screen a', function(evt) {
      evt.preventDefault();
      $('.product-images .thumbs .screen a').removeClass('active');
      $(this).addClass('active');
      $('.product-images .big-image').css('background-image', 'url("' + $(this).attr('href') + '")');
    });
    
     
    
    
    
    
    
    
    
    
    $(document).on('click', '.product-images a.prev', function(evt) {
      evt.preventDefault();
      theme.scrollProductImages(-1);
    });

    $(document).on('click', '.product-images a.next', function(evt) {
      evt.preventDefault();
      theme.scrollProductImages(1);
    });
  },

  updateProductImagesArrows: function() {
    $('.product-images a.prev, .product-images a.next').css('display', $('.product-images .thumbs .screen a:visible').length > 5 ? 'block' : 'none');

    if ($('.product-images .thumbs .screen a.active:visible').length == 0) {
      $('.product-images .thumbs .screen a:visible').first().trigger('click');
    }
  },

  scrollProductImages: function(offset) {
    var thumbScreen = $('.product-images .thumbs .screen');
    var imageWidth = thumbScreen.find('a').outerWidth();
    var thumbsCount = thumbScreen.find('a:visible').length;
    var thumbsPerPage = thumbScreen.width() / imageWidth;
    var currentImage = Math.round($('.product-images .thumbs .screen').scrollLeft() / imageWidth);
    var targetImage = (currentImage + offset);
    if (targetImage > thumbsCount - thumbsPerPage) {
      targetImage = 0;
    } else if (targetImage < 0) {
      targetImage = thumbsCount - thumbsPerPage;
    }
    var targetOffset = imageWidth * targetImage;
    $('.product-images .thumbs .screen').stop().animate({scrollLeft: targetOffset + 'px'}, 500);
  },

  initWarrantyPopup: function() {
    $(document).on('click', 'a[href="#warranty-popup"]', function(evt) {
      evt.preventDefault();
      $('.warranty-popup').addClass('active');
    });

    $(document).on('click', '.warranty-popup a.close', function(evt) {
      evt.preventDefault();
      $('.warranty-popup').removeClass('active');
    });
  },

  initFAQ: function() {
    $(document).on('click', '.faq dt', function(evt) {
      if ($(this).hasClass('active')) {
        $('.faq dt').removeClass('active');
        $('.faq dd').removeClass('visible');
      } else {
        $('.faq dd').removeClass('visible');
        $(this).addClass('active');
        $(this).next('dd').addClass('visible');
      }
    });
  },

  initPasswordReset: function() {
    if ($('#form-recover .errors').length || $('#form-recover .message').length) {
      $('#form-recover').addClass('visible');
      $('#form-login').addClass('hidden');
    }

    $(document).on('click', 'a[href="#recover"]', function(evt) {
      evt.preventDefault();

      $('#form-recover').addClass('visible');
      $('#form-login').addClass('hidden');
    });

    $(document).on('click', '#form-recover .cancel', function(evt) {
      evt.preventDefault();

      $('#form-recover').removeClass('visible');
      $('#form-login').removeClass('hidden');
    });
  },

  bannerTimer: null,
  initBanners: function() {
    if ($('.banner .message').length == 0) {
      $('.banner').remove();
      return;
    }
    $('.banner .message').first().addClass('active');
    $(document).on('click', '.banner .prev', function(evt) {
      evt.preventDefault();
      theme.showBanner(-1);
    });

    $(document).on('click', '.banner .next', function(evt) {
      evt.preventDefault();
      theme.showBanner(1);
    });

    if ($('.banner .message').length > 1) {
      $(document).on('mouseenter', '.banner', function() {
        if (theme.bannerTimer) {
          clearInterval(theme.bannerTimer);
          theme.bannerTimer = null;
        }
      });

      $(document).on('mouseleave', '.banner', function() {
        if (theme.bannerTimer) {
          clearInterval(theme.bannerTimer);
          theme.bannerTimer = null;
        }

        theme.bannerTimer = setInterval(function() {
          theme.showBanner(1);
        }, 5000);
      });

      theme.bannerTimer = setInterval(function() {
        theme.showBanner(1);
      }, 5000);
    }
  },

  showBanner: function(offset) {
    var curr = $('.banner .message.active');
    if (offset > 0) {
      var next = curr.next('.message');
      if (next.length == 0) {
        next = $('.banner .message').first();
      }
    } else {
      var next = curr.prev('.message');
      if (next.length == 0) {
        next = $('.banner .message').last();
      }
    }
    curr.removeClass('from-left')
        .removeClass('from-right')
        .removeClass('active')
        .addClass((offset > 0) ? 'to-left' : 'to-right');

    next.removeClass('to-left')
        .removeClass('to-right')
        .addClass((offset > 0) ? 'from-right' : 'from-left');

    if ($('.banner .message').length > 1) {
      setTimeout(function() {
        next.addClass('active');
      }, 1);
    }
  },

  initYoutube: function() {
    $('main iframe[src^="https://www.youtube.com/embed/"], main iframe[src^="https://youtube.com/embed/"]').each(function() {
      $(this).wrap('<div class="video-wrapper-wrapper"><div class="video-wrapper"></div></div>');
    });
  },

  initProDiscount: function() {
    // $.getJSON('/cart.json', function(cart) {
    //   console.log(cart);
    //   if (cart.cart_level_discount_applications.length == 0) {
    //     var redirect = window.location.href.replace(window.location.origin, '');
    //     window.location = '/discount/PRO/?redirect=' + encodeURIComponent(redirect);
    //   }
    //
    // })
  },

  initAddressEdit() {
    $('.edit-address').on('click', function() {
      var id = $(this).data('form-id');
      $('#edit-address-' + id).toggleClass('visible');
    });
    $('.cancel-edit-address').on('click', function() {
      var id = $(this).data('form-id');
      $('#edit-address-' + id).removeClass('visible');
    });
    $('.delete-address').on('click', function() {
      var id = $(this).data('form-id');
      if (confirm("Are you sure you wish to delete this address?")) {
        Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
      }
    });
    $('.add-address').on('click', function() {
      $('#address-new-form').addClass('visible');
    });
    $('.cancel-add-address').on('click', function() {
      $('#address-new-form').removeClass('visible');
    });
  },

  init: function() {
    this.initHeader();
    this.initMobileMenu();
    this.initPasswordReset();
    this.initProductImages();
    this.initProductTabs();
    this.initProductSizeGuide();
    this.initCollectionSorting();
    this.initSlideshow();
    this.initWarrantyPopup();
    this.initFAQ();
    this.initBanners();
    this.initYoutube();
    this.initProDiscount();
    this.initAddressEdit();
  }
};

$(document).ready(function() {
  theme.init();
});
